module.exports = __webpack_public_path__ + "word.svg?91cfd00203d5d77f62978090f4810bd4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/word.svg
// module id = 924
// module chunks = 2